import WidgetCoordinate          from "../../widget/WidgetCoordinate";
import WidgetId                  from "../../widget/WidgetId";
import WidgetTitle               from "../../widget/WidgetTitle";
import WidgetTypeClass           from "../../widget/WidgetTypeClass";
import WidgetValue               from "../../widget/WidgetValue";
import CustomerRecordWidgetId    from "./CustomerRecordWidgetId";
import CustomerRecordWidgetItems from "./item/CustomerRecordWidgetItems";

class CustomerRecordWidget {
  constructor(
    private readonly _id: CustomerRecordWidgetId = new CustomerRecordWidgetId(),
    private readonly _widgetId: WidgetId = new WidgetId(),
    private readonly _type: WidgetTypeClass = new WidgetTypeClass(),
    private readonly _coordinate: WidgetCoordinate = new WidgetCoordinate(),
    private readonly _title: WidgetTitle = new WidgetTitle(),
    private readonly _value: WidgetValue = new WidgetValue(),
    private readonly _items: CustomerRecordWidgetItems = new CustomerRecordWidgetItems(),
  ) {
  }

  get id() {
    return this._id;
  }

  get widgetId() {
    return this._widgetId;
  }

  get type() {
    return this._type;
  }

  get coordinate() {
    return this._coordinate;
  }

  get title() {
    return this._title;
  }

  get value() {
    return this._value;
  }

  get items() {
    return this._items;
  }
}

export default CustomerRecordWidget;
